<div class="separador">
  <div class="contenido m-auto">
    <img class="imagen" src="../../../assets/img/foto-frase.jpeg" alt="">

    <div class="frase texto ml-2">
      <p class="text-center text-white"><i>"Padre no es el que engendra a un hijo, <br> sino el que da la vida por el.
          <br> La vida
          se entrega con
          generosidad, <br> con ternura, con firmesa, con dedicacion, <br> descubiendo lo que el hijo y la familia <br>
          necesitan. Esta
          entrega debe ser una necesidad, <br> un sentimiento que nos haga sentir <br> dignos hijos de Dios" </i>
      </p>
      <p class="text-right"><em class="text-muted ">P. Juan</em></p>
    </div>
  </div>
</div>
